/** Product name – always written with a space and capitals ("Kaleido Lab"). */
export const APP_NAME = "Kaleido Lab";
